// extracted by mini-css-extract-plugin
export default {"eventsCardList":"EventsCardList_eventsCardList__3TxJn","card":"EventsCardList_card__4CaQJ"};